import React from 'react';
import { connect } from 'react-redux';

import { loginStatus } from '../../store/modules/login';
import { fetchTask } from '../../store/modules/task';
import {
  fetchCompany,
  setCompanyForm,
  deleteCompany,
} from '../../store/modules/company';
import {
  fetchProject,
  setProjectForm,
  deleteProject,
} from '../../store/modules/project';
import {
  fetchActivity,
  setActivityForm,
  deleteActivity,
} from '../../store/modules/activity';
import { fetchNote, deleteNote } from '../../store/modules/note';
import { fetchNotification } from '../../store/modules/notification';
import { fetchFile } from '../../store/modules/file';
import {
  fetchPerson,
  setPersonForm,
  deletePerson,
} from '../../store/modules/person';
import {
  fetchStaff,
  setStaffForm,
  deleteStaff,
} from '../../store/modules/staff';
import { setServiceKeyForm } from '../../store/modules/servicekey';
import { setNumberRangeForm } from '../../store/modules/numberrange';
import { fetchTotalData } from '../../store/modules/totaldata';
import { addFeedback } from '../../store/modules/feedback';

import ActionButton from './component';

const mapActionCreators = {
  loginStatus,
  fetchTotalData,
  fetchTask,
  fetchCompany,
  fetchProject,
  fetchActivity,
  fetchFile,
  fetchPerson,
  fetchStaff,
  fetchNote,
  fetchNotification,
  setActivityForm,
  setCompanyForm,
  setProjectForm,
  setStaffForm,
  setPersonForm,
  setServiceKeyForm,
  setNumberRangeForm,
  deleteCompany,
  deleteProject,
  deleteActivity,
  deletePerson,
  deleteStaff,
  deleteNote,
  addFeedback,
};

const mapStateToProps = state => ({
  fetchingTask: state.task.fetching,
  fetchingCompany: state.company.fetching,
  fetchingActivity: state.activity.fetching,
  fetchingPerson: state.person.fetching,
  fetchingStaff: state.staff.fetching,
  fetchingProject: state.project.fetching,
  fetchingNote: state.note.fetching,
  fetchNotification: state.notification.fetching,
  currentTask: state.task.current,
  currentCompany: state.company.current,
  currentActivity: state.activity.current,
  currentPerson: state.person.current,
  currentStaff: state.staff.current,
  currentProject: state.project.current,
  sidebarOpen: state.options.sidebarOpen,
  token: state.login.token,
  router: state.router,
  limits: state.limits.limits,
});

export default connect(mapStateToProps, mapActionCreators)(ActionButton);



// WEBPACK FOOTER //
// ./src/components/ActionButton/container.js